import useApiMutation from 'shared/hooks/use-api-mutation';

const useResetPasswordRequest = () => {
  return useApiMutation({
    method: 'POST',
    url: '/auth/reset-password/request',
    errorTitle: 'Erro ao solicitar alteração de senha senha',
    successTitle: 'Redefinir senha',
    successMessage: 'Um link para alterar a senha foi enviado no seu email!',
  });
};

export default useResetPasswordRequest;
